import {ProductCollectionComponent} from "./ProductCollectionComponent";
import React from "react";
import {BASE_URL} from "../Const";

export default function GlobalProvider() {

    const queryString = window.location.href.replace(BASE_URL, "")

    localStorage.setItem("pending_shop_key", queryString)
    return <ProductCollectionComponent id={queryString}/>

}
